/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

const DEFAULT_TITLE = 'Consulta de Histórico Veicular por Placa | AboutCar';
const DEFAULT_DESCRIPTION = 'Consulta de placa, histórico de veículo, leilão, restrições, sinistro, segurança, roubo e furto, aceitação em seguradoras, quilometragem, recall, proprietários e muito mais.';
const DEFAULT_KEYWORDS = 'consulta veicular, consulta placa, consultar placa, consulta histórico, histórico veículo, verificar placa, leilão de veículos, restrições de veículo, roubo/furto, chassi, renavam, fipe, laudo veicular';
const SITE_URL = process.env.WEB_URI || 'https://aboutcar.com.br';
const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/images/aboutcar-classifieds.png`;

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  canonical,
  ogType = 'website',
  ogImage = DEFAULT_OG_IMAGE,
  noindex = false,
  schema = null,
}) {
  const router = useRouter();
  const pageTitle = title ? (title.includes('AboutCar') ? title : `${title} | AboutCar`) : DEFAULT_TITLE;
  const pageCanonical = canonical || `${SITE_URL}${router.asPath.split('?')[0]}`;
  const pageOgImage = ogImage.startsWith('http') ? ogImage : `${SITE_URL}${ogImage}`;

  const schemas = Array.isArray(schema) ? schema : (schema ? [schema] : []);

  return (
    <Head>
      <title key="title">{pageTitle}</title>
      <meta name="description" content={description} key="description" />
      {keywords && <meta name="keywords" content={keywords} key="keywords" />}
      <meta name="author" content="AboutCar" key="author" />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} key="robots" />
      <meta name="revisit-after" content="1 day" key="revisit-after" />
      <meta name="language" content="Portuguese" key="language" />
      <link rel="canonical" href={pageCanonical} key="canonical" />

      {/* Open Graph */}
      <meta property="og:locale" content="pt_BR" key="og:locale" />
      <meta property="og:type" content={ogType} key="og:type" />
      <meta property="og:title" content={pageTitle} key="og:title" />
      <meta property="og:description" content={description} key="og:description" />
      <meta property="og:url" content={pageCanonical} key="og:url" />
      <meta property="og:site_name" content="AboutCar" key="og:site_name" />
      <meta property="og:image" content={pageOgImage} key="og:image" />
      <meta property="og:image:secure_url" content={pageOgImage} key="og:image:secure_url" />
      <meta property="og:image:type" content="image/png" key="og:image:type" />
      <meta property="og:image:width" content="1200" key="og:image:width" />
      <meta property="og:image:height" content="630" key="og:image:height" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
      <meta name="twitter:title" content={pageTitle} key="twitter:title" />
      <meta name="twitter:description" content={description} key="twitter:description" />
      <meta name="twitter:image" content={pageOgImage} key="twitter:image" />

      {/* Structured Data (JSON-LD) */}
      {schemas.map((item, index) => (
        <script
          key={`schema-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </Head>
  );
}
